import { useCallback, useContext } from 'react';
import { UnsavedEditContext } from '../context/UnsavedEditContext';

/**
 * Действие уводит со страницы целиком мимо роутера (смена учётной записи): как уход по ссылке — правки, которые
 * решают сами (`beforeLeave`: черновик досохраняется), — до действия, о прочих несохранённых — вопрос. В отличие от
 * `useConfirmDiscard`, автосохраняемая правка не остаётся висеть до `pagehide`, где ушла бы уже с чужим токеном.
 */
export const useConfirmLeave = (): ((action: () => void) => void) => {
    const area = useContext(UnsavedEditContext);
    return useCallback(
        (action: () => void) => {
            if (!area?.blocksLeave()) {
                action();
                return;
            }
            area.confirmLeave((leave) => {
                if (leave) action();
            });
        },
        [area],
    );
};
